(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["obx-boc-video-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
    var videoPlaceholder = document.querySelector(".video-placeholder");

    if (videoPlaceholder) {
        videoPlaceholder.addEventListener("click", function () {
            var videoWrapper = document.querySelector(".video-wrapper");
            var videoUrl = videoPlaceholder.getAttribute("data-embed");

            if (videoWrapper && videoUrl) {
                // Fix: Ensure correct URL formatting
                var autoplayUrl = videoUrl.includes("?") ? videoUrl + "&autoplay=1" : videoUrl + "?autoplay=1";

                // Create iframe
                var iframe = document.createElement("iframe");
                iframe.setAttribute("width", "560");
                iframe.setAttribute("height", "315");
                iframe.setAttribute("src", autoplayUrl);
                iframe.setAttribute("title", "YouTube video player");
                iframe.setAttribute("frameborder", "0");
                iframe.setAttribute("allow", "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; autoplay");
                iframe.setAttribute("referrerpolicy", "strict-origin-when-cross-origin");
                iframe.setAttribute("allowfullscreen", "true");

                // Remove placeholder and inject iframe
                videoPlaceholder.style.display = "none";
                videoWrapper.appendChild(iframe);
            }
        });
    }
});


  } catch(e) { console.error(e); }
})();
})();
